import styled from "@emotion/styled";

export const DateContainer = styled.div`
  display: flex;
  grid-gap: 0.25rem;
  flex-wrap: nowrap;
`;

export const DateDivider = styled.div`
  margin-top: 0.65rem;
`;
